import {
  ApiBlobGetRequest,
  ApiGetRequest,
  // ApiPostRequest,
  // ApiDeleteRequest,
  // ApiPutRequest,
} from '../../../api';
// import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Report - Stock Container',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/report',
      },
      {
        text: 'Report - Stock Container',
        href: '/adm/opr/report/container-out',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_container_stock',
    sortDesc: true,
    fields: [
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'condition',
        label: 'Condition',
        sortable: true,
      },
      {
        key: 'payload',
        label: 'Payload',
      },
      {
        key: 'exvessel_voy',
        label: 'Ex Vessel',
        sortable: true,
      },
      {
        key: 'remark_survey',
        label: 'Remark',
        sortable: true,
      },
      {
        key: 'tgl_eir_in',
        label: 'In',
        sortable: true,
      },
      {
        key: 'tgl_eir_out',
        label: 'Out',
        sortable: true,
      },
      {
        key: 'long_day',
        label: 'Long',
        sortable: true,
      },
      {
        key: 'total_price',
        label: 'Total',
        sortable: true,
      },
      {
        key: 'payment',
        label: 'Payment',
        sortable: true,
      },
    ],
    detail: false,
    form: {
      id_principle: '',
      principle_code: '',
      principle_name: '',
      id_consignee: '',
      consignee_code: '',
      consignee_name: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  reportContStock(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getReportContainerStock({ commit, state }) {
    commit('reportContStock', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
    };

    let result = await ApiGetRequest(`opr/report/container-stock`, params);
    commit('reportContStock', {
      items: result.data.object || [],
      total: result.data.total || 0,
      loading: false,
    });

    return result.error ? false : true;
  },

  async getExportReportContainerStock({ commit, state }) {
    commit('reportContStock', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      export: 1,
    };

    let result = await ApiBlobGetRequest(`opr/report/container-stock`, params);
    commit('reportContStock', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      var blob = new Blob([result.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'report_container_stock.xlsx';

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);

      return true;
    }
  },
};
